module.exports = __webpack_public_path__ + "static/media/Logo_AIGA.87df1758.svg";